import { ClientApiError } from '~/commons/interfaces/errors/ApiError'

export function getFirstErrorCode(error: ClientApiError): string | undefined {
  return error?.messages?.[0]?.code
}
